
















import { Component, Mixins, VModel } from "vue-property-decorator"

import ModelSetter from '../../../../../../../Mixins/ModelSetter'
import { UseFields } from "../../../../../../Pi"
import { RunFlowNodeButtonData } from './index'

@Component
export default class RunFlowNodeButtonSetupView extends Mixins<ModelSetter, UseFields>(ModelSetter, UseFields) {
  @VModel() model!: RunFlowNodeButtonData
}
